import React from "react";
import { ButtonLink } from "../components/ui-kit";

export default function NotFound() {
  return (
    <section className="bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 text-center">
        <p className="text-lg font-semibold text-orange-700">Page not found</p>
        <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-stone-900">
          We couldn't find that page
        </h1>
        <p className="mt-5 text-lg text-stone-700 leading-relaxed">
          The page you were looking for may have moved. Let's get you back on track.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
          <ButtonLink to="/" data-testid="notfound-home-button">
            Back to home
          </ButtonLink>
          <ButtonLink to="/contact" variant="secondary" data-testid="notfound-contact-button">
            Contact us
          </ButtonLink>
        </div>
      </div>
    </section>
  );
}
